import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { UserAuthorizeGet } from "entities/generated/back/data-contracts";

const initialState = {
    isAuth: false,
    initClient: false,
    img: "",
    user: {} as UserAuthorizeGet,
};

export type LoginStateType = typeof initialState;

const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        logIn: (
            state: LoginStateType,
            action: PayloadAction<UserAuthorizeGet>
        ) => {
            state.isAuth = true;
            state.user = { ...state.user, ...action.payload };
        },
        logOut: (state: LoginStateType) => (state = { ...initialState }),
        //TODO: Убрать из redux changeAvatar и img
        changeAvatar: (state: LoginStateType, action: PayloadAction<string>) => {
            state.img = action.payload;
        },
        initClient: (state: LoginStateType) => {
            state.initClient = true;
        },
    },
});

export const { logIn, logOut, changeAvatar, initClient } = loginSlice.actions;

export default loginSlice.reducer;
